<template>
  <div>
    <FuncionalidadeHeader
      v-if="funcData.parametros.textos.confirmarCodigoTituloNavegacao"
      :titulo="funcData.parametros.textos.confirmarCodigoTituloNavegacao"
      :custom-voltar="true"
      :info="false"
      :login="true"
      @click="$emit('voltar')"
    />
    <p
      v-if="funcData.parametros.textos.confirmarCodigoCabecalho"
      class="recuperar-cabecalho"
    >
      {{ funcData.parametros.textos.confirmarCodigoCabecalho }}
    </p>
    <h4>Insira o código recebido</h4>

    <CodeInput
      @check="enviar"
      ref="codeInput"
    />

    <span class="recuperar-contador">Código expira em {{contador}}</span>

    <p
      v-if="funcData.parametros.textos.confirmarCodigoRodape"
      class="recuperar-rodapé"
    >
      {{ funcData.parametros.textos.confirmarCodigoRodape }}
    </p>
    <p
      class="recuperar-rodapé"
    >
      Não recebeu nenhum código? Lembre de checar sua caixa de SPAM ou <a class="voltar-link" @click="voltar">envie para outro contato</a>.
    </p>
    <AlertaErro
      v-model="erro.show"
      :title="erro.titulo"
      :description="erro.descricao"
    />
    <LoadingModal
      :show="loading.show"
      :sucesso="loading.sucesso"
      :texto="loading.texto"
    />
  </div>
</template>

<script>
import AlertaErro from '@/components/AlertaError/AlertaErro'
import { mapGetters, mapState } from 'vuex'
import CodeInput from '@/views/137/etapas/CodeInput'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import LoadingModal from '@/components/LoadingModal/LoadingModal'

export default {
  name: 'RecuperarSenhaCodigo',
  components: { LoadingModal, FuncionalidadeHeader, CodeInput, AlertaErro },
  props: {
    contato: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: {},
      erro: {
        show: false,
        titulo: 'Erro no preenchimento:',
        descricao: ''
      },
      loading: {
        show: false,
        sucesso: false,
        texto: 'Validando código'
      },
      selecionado: null,
      contadorInterval: null,
      contador: '10:00',
      // segundos
      timer: 600
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState('SetupApp', ['config', 'apiAcesso', 'frameId']),
    ...mapGetters('SetupApp', ['estilo']),
    funcData () {
      return this.config.configuracaoAcesso.recuperarSenha
    },
    buttonStyle () {
      return {
        'background-color': this.estilo.aplicacao.corPrimariaAplicacao
      }
    },
    styleSecundario () {
      return {
        'background-color': this.estilo.aplicacao.corSecundariaAplicacao
      }
    }
  },
  methods: {
    async init () {
      this.iniciaContador()
    },
    iniciaContador () {
      if (this.contadorInterval) {
        clearInterval(this.contadorInterval)
      }

      // Segundos
      this.timer = 60 * 10
      this.contadorInterval = setInterval(() => {
        let minutes = parseInt(this.timer / 60, 10)
        let seconds = parseInt(this.timer % 60, 10)

        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds

        this.contador = `${minutes}:${seconds}`

        if (--this.timer < 0) {
          clearTimeout(this.contadorInterval)
          this.voltar()
        }
      }, 1000)
    },
    showError () {
      this.erro.descricao = `<ul><li>Código invalido</li></ul>`
      this.erro.show = true
    },
    startLoading () {
      this.loading.sucesso = false
      this.loading.texto = 'Validando código'
      this.loading.show = true
    },
    async enviar (code) {
      this.startLoading()
      this.erro.show = false

      if (!code) {
        this.$refs.codeInput.code = ''
        return this.showError()
      }

      const payload = {
        code
      }

      const response = await this.apiAcesso.recuperarSenha.recuperarSenhaConfirmarCodigo({
        payload,
        handlerErrorIgnore: [401, 404]
      })

      if (response.status) {
        setTimeout(() => {
          this.loading.sucesso = true
          this.loading.texto = 'Código validado. Aguarde...'
          setTimeout(() => {
            this.loading.show = false
            this.$emit('submit', code)
          }, 2500)
        }, 1000)
      } else {
        this.loading.show = false
        this.$refs.codeInput.code = ''
        this.erro.descricao = `<ul><li>${response.message}</li></ul>`
        this.erro.show = true
      }
    },
    voltar () {
      this.$emit('voltar')
    }
  }
}
</script>

<style scoped>
.recuperar-cabecalho {
  letter-spacing: 0;
  color: #333333;
  margin: 0 0 50px;
}

.recuperar-rodapé {
  font: normal normal normal 14px/19px Open Sans;
  letter-spacing: 0;
  color: #333333;
  margin-top: 60px;
  margin-bottom: 15px;
}

.voltar-link {
  font: normal normal 600 14px/19px Open Sans;
  color: #333333;
  cursor: pointer;
}

h4 {
  font-size: 16px;
  font-weight: 600;
}

.recuperar-contador {
  font-size: 12px;
  color: #555555;
}
</style>
